export const FACTORY_ADDRESS = '0xb9b001b11c9365A6f440adccFeCF345aEa724881'

export const BUNDLE_ID = '1'

// AIC chain constants
export const WETH_ADDRESS = '0x4bdC4C23c0D9bdceefe9AaB8d946DA16b75E03Fb'
export const USDI_ADDRESS = '0xD359Ebfa22d6caFe8Ff49b9e45859F688243CdAC'
export const AIC_USDI_PAIR = '0x63b873505E355A495CeCD6f7E1eD471Bdcf60221'
// Main/token subgraphs currently start indexing from this block.
export const MIN_INDEXED_BLOCK = 478999

export const timeframeOptions = {
  WEEK: '1 week',
  MONTH: '1 month',
  // THREE_MONTHS: '3 months',
  // YEAR: '1 year',
  HALF_YEAR: '6 months',
  ALL_TIME: 'All time',
}

export const klineTimeOptions = {
  M15: '15m',
  H1: '1h',
  H4: '4h',
  D4: '4d',
  WEEK: timeframeOptions.WEEK,
  MONTH: timeframeOptions.MONTH,
  ALL_TIME: timeframeOptions.ALL_TIME,
}

// token list urls to fetch tokens from - use for warnings on tokens and pairs
export const SUPPORTED_LIST_URLS__NO_ENS = []

// hide from overview list
export const TOKEN_BLACKLIST = []

// pair blacklist
export const PAIR_BLACKLIST = []

// pairs that bypass token safety warning gate
export const PAIR_WARNING_WHITELIST = ['0x63b873505e355a495cecd6f7e1ed471bdcf60221']

// tokens that bypass token safety warning gate
export const TOKEN_WARNING_WHITELIST = [
  '0x4bdc4c23c0d9bdceefe9aab8d946da16b75e03fb',
  '0xd359ebfa22d6cafe8ff49b9e45859f688243cdac',
]

// warnings to display if page contains info about blocked token
export const BLOCKED_WARNINGS = {}

/**
 * For tokens that cause erros on fee calculations
 */
export const FEE_WARNING_TOKENS = []

export const UNTRACKED_COPY = 'Derived USD values may be inaccurate without liquid stablecoin or AIC pairings.'

// pairs that should be tracked but arent due to lag in subgraph
export const TRACKED_OVERRIDES_PAIRS = []

// tokens that should be tracked but arent due to lag in subgraph
// all pairs that include token will be tracked
export const TRACKED_OVERRIDES_TOKENS = []
